import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9fdtkkw55p: FaireBrandEntity = {
  token: "b_9fdtkkw55p",
  type: "brand",
  name: "Uncle's Thai Food",
  avatarUrl:
    "https://cdn.faire.com/fastly/82c92d52914801cd9d864f2c60c119ffd6d82325379444415f1368b26d4ec0b5.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/82c92d52914801cd9d864f2c60c119ffd6d82325379444415f1368b26d4ec0b5.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/82c92d52914801cd9d864f2c60c119ffd6d82325379444415f1368b26d4ec0b5.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/82c92d52914801cd9d864f2c60c119ffd6d82325379444415f1368b26d4ec0b5.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 8,
  isTopShop: true,
  isInsider: true,
  description:
    "Uncle's wants you to cook more Thai food. So we make not so traditional pantry items that make it fun and easy to cook like our first of its kind freeze-dried instant Thai curry blocks.\n\nThe company was started by Brendan Chareoncharutkun, a former farmer and line cook who splits time between New York and Bangkok. The name \"Uncle's\" comes from cooking with his niece and nephews.",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:19:25.917Z",
    importedBy: "entity-db-cli",
  },
};
